<div class="delivery-address-wrapper">
  <div class="heading-wrapper">
    <span class="title">{{ 'myAccount.shipToAddress' | cxTranslate }}</span>
    <span class="sub-title">{{ 'myAccount.selectOneOrMultiple' | cxTranslate }}</span>
  </div>
  <ng-container *ngIf="unitAddressList$ | async as data">
    <div class="address-wrapper">
      <ng-container *ngFor="let address of data.addresses">
        <mat-checkbox
          #addressCheckbox
          *ngIf="address.approvalStatus !== 'PENDING'"
          disableRipple
          class="address-checkbox"
          [checked]="compareValue(address, userAddresses)"
          (change)="onChangeEventFunc(address, $event)"
        >
          <span *ngIf="address.addressName" class="address-name">{{ address.addressName }}: </span>
          {{ address.formattedAddress }}
        </mat-checkbox>
      </ng-container>
    </div>
  </ng-container>
</div>
